import * as LoadingStatus from '@dragonfruit/constants/loadingState';
import config from '@dragonfruit/config';

export const types = {
  CHECKOUT_2C2P_REQUEST: 'CHECKOUT_2C2P_REQUEST',
  CHECKOUT_2C2P_SUCCESS: 'CHECKOUT_2C2P_SUCCESS',
  CHECKOUT_2C2P_FAILURE: 'CHECKOUT_2C2P_FAILURE',

  GET_2C2P_BANKS: 'GET_2C2P_BANKS',
  GET_2C2P_BANKS_SUCCESS: 'GET_2C2P_BANKS_SUCCESS',
  GET_2C2P_BANKS_FAILURE: 'GET_2C2P_BANKS_FAILURE',

  RESET_2C2P_INFO: 'RESET_2C2P_INFO',
  RESET_2C2P_HASH: 'RESET_2C2P_HASH',
};

export const actions = {
  checkout2C2PInfo: ({ paymentMethodId, agentCode, gtmData }) => ({
    type: types.CHECKOUT_2C2P_REQUEST,
    paymentMethodId,
    agentCode,
    gtmData,
  }),
  checkout2C2PSuccess: checkoutInfo => {
    const {
      orderId,
      amount,
      payment2C2PEndpoint,
      currency,
      merchantId,
      version,
      hashValue,
      paymentOption,
      paymentDesc,
    } = checkoutInfo;

    return {
      type: types.CHECKOUT_2C2P_SUCCESS,
      payload: {
        orderId,
        amount,
        payment2C2PEndpoint,
        currency,
        merchantId,
        version,
        hashValue,
        paymentOption,
        paymentDesc,
      },
    };
  },
  checkout2C2PFail: () => ({ type: types.CHECKOUT_2C2P_FAILURE }),
  get2C2PBanks: () => ({ type: types.GET_2C2P_BANKS }),
  get2C2PBanksSuccess: banks => ({
    type: types.GET_2C2P_BANKS_SUCCESS,
    payload: {
      banks,
    },
  }),
  get2C2PBanksFail: () => ({
    type: types.GET_2C2P_BANKS_FAILURE,
  }),
  reset2C2PInfo: () => ({ type: types.RESET_2C2P_INFO }),
  reset2C2PHash: () => ({ type: types.RESET_2C2P_HASH }),
};

const initialState = {
  orderId: '',
  amount: '',
  paymentOption: 'A', // ref: https://developer.2c2p.com/docs/payment-channel-options
  callbackEndpoint: config.CALLBACK_BACKEND_API_FOR_2C2P, // BE api
  currency: 0, // ref: https://developer.2c2p.com/docs/references-3#section--currency-codes-
  merchantId: '',
  version: '',
  payment2C2PEndpoint: '',
  hashValue: '',
  paymentDesc: '',
  banks: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHECKOUT_2C2P_REQUEST:
      return {
        ...state,
        loadingStatus: LoadingStatus.LOADING,
      };
    case types.CHECKOUT_2C2P_SUCCESS:
      return {
        ...state,
        loadingStatus: LoadingStatus.READY,
        orderId: action.payload.orderId,
        amount: action.payload.amount,
        payment2C2PEndpoint: action.payload.payment2C2PEndpoint,
        currency: action.payload.currency,
        merchantId: action.payload.merchantId,
        version: action.payload.version,
        hashValue: action.payload.hashValue,
        paymentOption: action.payload.paymentOption,
        paymentDesc: action.payload.paymentDesc,
      };
    case types.CHECKOUT_2C2P_FAILURE:
      return {
        ...state,
        loadingStatus: LoadingStatus.ERROR,
      };
    case types.GET_2C2P_BANKS:
      return {
        ...state,
        loadingStatus: LoadingStatus.LOADING,
      };
    case types.GET_2C2P_BANKS_SUCCESS:
      return {
        ...state,
        banks: action.payload.banks,
      };
    case types.GET_2C2P_BANKS_FAILURE:
      return {
        ...state,
        loadingStatus: LoadingStatus.ERROR,
      };
    case types.RESET_2C2P_INFO:
      return {
        ...initialState,
      };
    case types.RESET_2C2P_HASH:
      return {
        ...state,
        hashValue: initialState.hashValue,
      };
    default:
      return state;
  }
};

export default reducer;

export const getOrderId = state => state.checkout2C2P.orderId;
export const getAmount = state => state.checkout2C2P.amount;
export const getPaymentOption = state => state.checkout2C2P.paymentOption;
export const getCallbackEndpoint = state => state.checkout2C2P.callbackEndpoint;
export const getCurrency = state => state.checkout2C2P.currency;
export const getMerchantId = state => state.checkout2C2P.merchantId;
export const getVersion = state => state.checkout2C2P.version;
export const getPayment2C2PEndpoint = state =>
  state.checkout2C2P.payment2C2PEndpoint;
export const getHashValue = state => state.checkout2C2P.hashValue;
export const getPaymentDesc = state => state.checkout2C2P.paymentDesc;
export const getBanks = state => state.checkout2C2P.banks;



// WEBPACK FOOTER //
// ./app/redux/purchase/checkout2C2P.js